export const dexIntoJs: introJs.Step[] = [
  {
    title: '<span data-testid="welcome-section">WELCOME</span>',
    intro:
      '<div>Welcome to Mizar. Let&apos;s take a minute to learn how to best use Mizar, and become the best on-chain trader 💯\n' +
      '\n <br/><br/> Click on the <b>X</b> to exit the tutorial.</div>',
  },

  {
    title: '<span>TERMINAL</span>',
    element: '#snipe',
    intro:
      'In the Terminal, you can trade any token across Solana, Base, Ethereum, and BNB chains on all supported DEXs.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span>TRADES</span>',
    element: '#trades',
    intro:
      'Track and manage all your active trades, and review your full trading history.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span data-testid="research-section">RESEARCH</span>',
    element: '#research',
    intro:
      'Use the Research dashboard to find the hottest tokens, the best wallets, smart waps, and explore new launches.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span>BOTS</span>',
    element: '#bots',
    intro:
      'Create volatility bots that automatically swings for your on-chain, or copy-trade other wallets.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span>CONNECT TO TELEGRAM</span>',
    element: '#telegram',
    intro:
      'Connect your account to Telegram and manage all your trades directly from your phone.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span>SWITCH CHAIN</span>',
    element: '#chains',
    intro:
      'Switch chains and explore the supported markets: Ethereum, Base, and BNB Chain.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    element: '#account_star',
    title: '<span data-testid="account-section">ACCOUNT</span>',
    intro:
      '<div class="pb-2">By clicking on the <b>STAR</b>, you will get access to your account settings:</div>' +
      '<ul >' +
      '<li><b>Account</b>: edit and visualise your account settings, including notifications.</li>' +
      '<li><b>Staking</b>: by staking your $MZR tokens, you can lower your volume fees and gain entry into competitions.</li>' +
      '<li><b>Rewards</b>: invite your friends on Mizar and get up to 20% commission.</li>' +
      '</ul>',
    position: 'right',
  },

  {
    title: '<span data-testid="last-step-section">LAST STEP</span>',
    intro:
      '<div>All set for now! <i class="mdi mdi-checkbox-marked-circle text-blue-500"></i>  Check out our <a href="https://docs.mizar.com/sniper-bot-manual" target="_blank" rel="noopener noreferrer">Sniper bot manual</a> to learn even more about how our trading bots work, and to increase your profitability before starting to trade. ' +
      '<br/><br/>Join our <a href="https://discord.com/invite/gM4mAYMeWG" target="_blank" rel="noopener noreferrer">Discord</a> community to find hot alpha!</div>',
  },
];
